import { render, staticRenderFns } from "./x-spinner.vue?vue&type=template&id=c71e738a&"
import script from "./x-spinner.vue?vue&type=script&lang=js&"
export * from "./x-spinner.vue?vue&type=script&lang=js&"
import style0 from "./x-spinner.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c71e738a', component.options)
    } else {
      api.reload('c71e738a', component.options)
    }
    module.hot.accept("./x-spinner.vue?vue&type=template&id=c71e738a&", function () {
      api.rerender('c71e738a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-spinner.vue"
export default component.exports